export default "__VITE_ASSET__CE7_V6Pd__"